import { ExportButton } from '@/common/buttons/ExportButton';
import { Grid } from '@/common/grid/Grid';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { DateUtils } from '@/common/utils/DateUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

export const CalcProdPpTrxViewer = () => {

  const { navState } = useNavState();
  const rsrc = useRsrc();
  const module = useModuleFromRoute();

  const [title, setTitle] = useState();
  const gridRef = useRef();

  const [fieldDefs, setFieldDefs] = useState();
  const [exportReq, setExportReq] = useState();

  useEffect(() => {
    const viewerReqParam = navState.viewerReqParam;
    rsrc.viewerFieldDefs(module, 'CALC_PP_TRX_VIEWER_PLUGIN', viewerReqParam, navState.entity).then(fieldDefs => {
      setFieldDefs(fieldDefs);
    })

    setTitle('Trxs for ' + viewerReqParam.ndc11 + ' at ' + viewerReqParam.data.price);

  }, [])

    const buildAndSetExportReq = (reqParam, plugin) => {
      const exportReq = {
        timeZoneName: DateUtils.timeZoneName(),
        name: navState.title + ' Export',
        module,
        entity: 'CALC_PROD_PP',
        uiType: 'VIEWER',
        viewerPluginCode: 'CALC_PP_TRX_VIEWER_PLUGIN',
        viewerReqParam: reqParam,
        fieldDefs,
      };
  
      setExportReq(exportReq);
    }

  const onGridReady = (params) => {
    const dataSource = {
      getRows: (params) => {
        const reqParam = {
          ...navState.viewerReqParam,
          startRow: params.startRow,
          endRow: params.endRow,
        };

        const plugin = 'CALC_PP_TRX_VIEWER_PLUGIN';
        buildAndSetExportReq(reqParam, plugin);

        rsrc.viewerRows(module, plugin, reqParam, navState.entity).then(res => {
          gridRef.current.onGridSuccess(res, params);
          gridRef.current.resize();
        })

        rsrc.viewerCount(module, plugin, reqParam, navState.entity).then(count => {
          gridRef.current.setCount(count);
        })

        rsrc.viewerAggTotals(module, plugin, reqParam, navState.entity).then(aggTotals => {
          gridRef.current.setTotalsRow(aggTotals);
        })
      }
    }

    gridRef.current.setDataSource(dataSource);
  }

  return (
    fieldDefs &&
    <>
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Title icon={fas.faListUl} title={title} />
        <ExportButton exportReq={exportReq} />
      </Box>
      <Grid
        ref={gridRef}
        gridOptions={{ fieldDefs }}
        events={{ onGridReady }}

      />
    </>
  );
}